module.exports = __webpack_public_path__ + "media/images/lb/186-84db7bc8943fb97f7eb2f2ad8136a963.svg";